import React from 'react';

interface CheckboxButtonFormProps {
	title: string;
    // value는 'Y' 또는 'N'이어야 합니다.
    value : string;
	titleless?: boolean;
	name: string;
	editable?: boolean;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	wrapperOption?: {
		wrapperStyle: string;
		titleStyle: string;
		inputStyle: string;
	};
}

export const CheckboxButtonForm: React.FC<CheckboxButtonFormProps> = (props: CheckboxButtonFormProps) => {

	const { 
		title,
        value,
		titleless = false,
		name,
		editable = true,
		onChange,
		wrapperOption = {
			wrapperStyle: "w-[225px] min-w-[225px] mr-[10px] mb-[5px]",
			titleStyle: "w-[100px] min-w-[100px] text-left",
			inputStyle: "w-[75px] min-w-[75px] mr-[5px]"
		} 
	} = props;   

    const isChecked = value === 'Y';

    const handleClick = () => {
        if (!editable) return;
        
        const newValue = isChecked ? 'N' : 'Y';

        // 부모 컴포넌트가 기대하는 이벤트 객체 형태에 맞춰 전달합니다.
        onChange({
            target: { name, value: newValue }
        } as React.ChangeEvent<HTMLInputElement>);
    };

	return (
		<div className={`flex h-[20px] items-center ${wrapperOption.wrapperStyle}`}>
			<p className={`${wrapperOption.titleStyle} form-title mr-[5px] ${titleless ? 'hidden' : ''}`}>
				{title}
			</p>
			<div 
                className={`flex ${wrapperOption.inputStyle} items-center justify-center border border-gray-300 rounded-[4px] h-full
                        ${editable ? 'cursor-pointer' : 'bg-gray-100'}
                    `}
                onClick={handleClick}
            >
                <input 
                    id={name}
                    type="checkbox" 
                    name={name} 
                    className={`${editable ? 'cursor-pointer' : ''}`}
                    checked={isChecked}
                    disabled={!editable}
                    // 실제 로직은 부모 div의 onClick에서 처리하므로, React 경고를 피하기 위해 빈 함수를 전달합니다.
                    onChange={() => {}} 
                />
            </div>
		</div>
	)
}